<div class="form-page">
  <div class="form-page-chess" aria-hidden="true"></div>
  <div class="form-page-image" aria-hidden="true"></div>

  <div class="form-page-frame">
    <div class="form-page-row">
      <div class="form-page-visual">
        <div class="form-page-visual-stack">
          <button type="button" class="form-page-back-btn" (click)="goToLogin()">
            <i class="fas fa-arrow-left" aria-hidden="true"></i>
            <span>Back</span>
          </button>

          <div class="form-page-visual-copy-block">
            <div class="form-page-visual-copy">
              <h2>Join Your Organization on A-Square ERP</h2>
              <p>Accept your invitation and create your password to start working with your team.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="form-page-panel">
        <div class="forgot-form-center">
          <div class="forgot-form figma-auth-form">
            <div class="forgot-icon" aria-hidden="true">
              <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M22 13.333V10.667a6 6 0 1 0-12 0v2.666" stroke="#0076FE" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <rect x="6.667" y="13.333" width="18.667" height="13.333" rx="2.667" stroke="#0076FE" stroke-width="2"/>
                <circle cx="16" cy="20" r="1.333" fill="#0076FE"/>
                <path d="M16 21.333V24" stroke="#0076FE" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </div>

            <div class="forgot-form-intro">
              <div class="forgot-heading">
                @if (loadError) {
                  <h3>Invitation Unavailable</h3>
                  <p>{{ loadError }}</p>
                } @else if (activeStep === 'details' && invitation) {
                  <h3>You're Invited</h3>
                  <p>You have been invited to join <strong>{{ invitation.companyName }}</strong>. Review the details below and accept the invitation to continue.</p>
                } @else if (activeStep === 'password') {
                  <h3>Create Password</h3>
                  <p>Set a password for your account to complete the invitation.</p>
                } @else if (activeStep === 'success') {
                  <h3>Invitation Accepted</h3>
                  <p>Your password has been created. You can now sign in with your email and password.</p>
                }
              </div>
            </div>

            <div class="forgot-form-main">
              @if (!loadError && activeStep === 'details' && invitation) {
                <div class="forgot-form-body">
                  <div class="field-item">
                    <label>Email</label>
                    <div class="figma-input">
                      <input class="figma-input-field" [value]="invitation.emailID" readonly />
                    </div>
                  </div>
                  <div class="field-item">
                    <label>Username</label>
                    <div class="figma-input">
                      <input class="figma-input-field" [value]="invitation.username" readonly />
                    </div>
                  </div>
                  <div class="field-item">
                    <label>Company</label>
                    <div class="figma-input">
                      <input class="figma-input-field" [value]="invitation.companyName" readonly />
                    </div>
                  </div>
                  <div class="field-item">
                    <label>Role</label>
                    <div class="figma-input">
                      <input class="figma-input-field" [value]="invitation.roleName" readonly />
                    </div>
                  </div>
                  @if (expiryLabel) {
                    <p class="forgot-resend" style="font-style: italic;">{{ expiryLabel }}</p>
                  }
                  @if (actionError) {
                    <small class="field-error">{{ actionError }}</small>
                  }
                  <button class="forgot-submit-btn" type="button" [disabled]="isSubmitting" (click)="acceptInvitation()">
                    <span class="forgot-submit-btn-label">{{ isSubmitting ? 'Please wait...' : 'Accept Invitation' }}</span>
                  </button>
                </div>
              }

              @if (activeStep === 'password') {
                <form class="forgot-form-body" [formGroup]="passwordForm" (ngSubmit)="createPassword()">
                  <div class="field-item">
                    <label for="invite-pw">Password*</label>
                    <div class="figma-input">
                      <input
                        [type]="hide ? 'password' : 'text'"
                        class="figma-input-field"
                        id="invite-pw"
                        placeholder="Enter Password"
                        formControlName="Password"
                        autocomplete="new-password"
                        data-initial-focus
                      />
                      <button type="button" class="figma-input-toggle" (click)="hide = !hide" [attr.aria-label]="hide ? 'Show password' : 'Hide password'">
                        <i class="fas" [class.fa-eye]="hide" [class.fa-eye-slash]="!hide" aria-hidden="true"></i>
                      </button>
                    </div>
                    @if (passwordForm.get('Password')?.invalid && passwordForm.get('Password')?.touched) {
                      <small class="field-error">Please enter password.</small>
                    }
                  </div>

                  <div class="field-item">
                    <label for="invite-pw2">Confirm Password*</label>
                    <div class="figma-input">
                      <input
                        [type]="confirmhide ? 'password' : 'text'"
                        class="figma-input-field"
                        id="invite-pw2"
                        placeholder="Confirm Password"
                        formControlName="ConfirmPassword"
                        autocomplete="new-password"
                      />
                      <button type="button" class="figma-input-toggle" (click)="confirmhide = !confirmhide" [attr.aria-label]="confirmhide ? 'Show password' : 'Hide password'">
                        <i class="fas" [class.fa-eye]="confirmhide" [class.fa-eye-slash]="!confirmhide" aria-hidden="true"></i>
                      </button>
                    </div>
                    @if (passwordForm.get('ConfirmPassword')?.invalid && passwordForm.get('ConfirmPassword')?.touched) {
                      <small class="field-error">Please confirm password.</small>
                    }
                  </div>

                  @if (actionError) {
                    <small class="field-error">{{ actionError }}</small>
                  }

                  <button class="forgot-submit-btn" type="submit" [disabled]="isSubmitting">
                    <span class="forgot-submit-btn-label">{{ isSubmitting ? 'Saving...' : 'Create Password' }}</span>
                  </button>
                </form>
              }

              @if (activeStep === 'success') {
                <div class="forgot-form-body">
                  <button class="forgot-submit-btn" type="button" (click)="goToLogin()">
                    <span class="forgot-submit-btn-label">Go to Login</span>
                  </button>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
